import './MetricsSelector.scss';
import React, { useState, useEffect, useMemo } from 'react';
import { FlightSelect } from '@flybits/design-system';
import { METRIC_OPTIONS } from '../constants';
import { ChartConfigState, MetricOption } from 'pages/AnalyticsV2/types';

const MAIN_CLASS = 'metrics-selector';
const CLASSES = {
  LABEL: `${MAIN_CLASS}__label`,
  DD: `${MAIN_CLASS}__select`,
};

type TMetricsSelectorProps = {
  chartConfig: ChartConfigState;
  onChange: (metric?: MetricOption['value']) => void;
  onValidation: (isValid: boolean) => void;
};

export default function MetricsSelector({ chartConfig, onChange, onValidation }: TMetricsSelectorProps) {
  const { metrics } = chartConfig;

  const initialOption = useMemo(() => {
    let initOption: MetricOption = {
      key: 'none',
      name: 'None Selected',
      value: {
        title: '',
        entity: '',
        metric: '',
      },
    };

    if (metrics) {
      initOption =
        METRIC_OPTIONS.find((o) => o.value?.entity === metrics.entity && o.value?.metric === metrics.metric) ||
        initOption;
    }
    return initOption;
  }, [metrics]);

  const [selectedOption, setSelectedOption] = useState<MetricOption>();

  useEffect(() => {
    const isValid = !!selectedOption?.value || !!initialOption.value;
    onValidation(isValid);
  }, [selectedOption, initialOption, onValidation]);

  return (
    <section className={MAIN_CLASS}>
      <label className={CLASSES.LABEL} htmlFor="select-interval">
        Select a metric
      </label>
      <FlightSelect
        className={`${CLASSES.DD}`}
        options={METRIC_OPTIONS}
        selected={selectedOption || initialOption}
        width={'100%'}
        handleOptionClick={(option: (typeof METRIC_OPTIONS)[number]) => {
          setSelectedOption(option);
          onChange && onChange(option.value);
        }}
      />
    </section>
  );
}
